// packages/storefront/src/themes/createWidgetTheme.ts
import { createTheme, type Theme, type ThemeOptions } from '@mui/material/styles';
import type { WidgetBrandColors } from '@tourtask/types/api/v1/WidgetBrandColors';
import { sharedComponents } from '@tourtask/ui/theme/sharedComponents';

/**
 * A widget's MUI theme (the chat widget, the reviews wall and form): the shared component rules, the widget's own
 * (`components`), and the business's brand as `primary` once its answer carries it (docs/brand-colours.md phase 4).
 * Without it (before the answer, or from an API older than it) MUI's own primary, as the widgets always had.
 */
export function createWidgetTheme({
  brand,
  components,
}: {
  brand: WidgetBrandColors | undefined;
  components?: ThemeOptions['components'];
}): Theme {
  return createTheme({
    components: { ...sharedComponents, ...components },
    ...(brand === undefined ? {} : { palette: { primary: { main: `#${brand.accentColor}`, contrastText: `#${brand.onAccentColor}` } } }),
  });
}
